<template>
    <span>
        <font-awesome-icon
            icon="user-friends"
            fixed-width />
        <span>
            {{ changeWordingRegistrationBuy ? $t('menu.persons') : isCaregiver ? $t('menu.caregivers') : $t('menu.participants') }}
        </span>
        <span
            v-if="participatingPersonCount > 4"
            :class="{'d-md-none': mobileMenu}">
            <font-awesome-layers
                fixed-width
                class="fa-lg">
                <font-awesome-icon
                    icon="circle"
                    class="text-primary"
                    transform="down-2" />
                <font-awesome-layers-text
                    class="font-weight-bold text-white"
                    :transform="(mobileMenu ? 'down-2 ' : 'down-1 ') + ((participatingPersonCount > 99) ? 'shrink-9 right-1' : 'shrink-7')"
                    :value="participatingPersonCount > 99 ? '99+' : participatingPersonCount" />
            </font-awesome-layers>
        </span>
    </span>
</template>
<script>
import registrationOnlineRegistrationFieldsMixin from "@/mixins/registration/registrationOnlineRegistrationFieldsMixin";
import registrationCaregiverMixin from "@/mixins/registration/registrationCaregiverMixin";

export default {
    name: 'MenuItemParticipants',
    mixins: [registrationOnlineRegistrationFieldsMixin, registrationCaregiverMixin],
    props: {
        mobileMenu: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        participatingPersonCount() {
            return this.participatingPersons?.length ?? 0
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
